import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

interface MasterClassErrorProps {
  onRetry: () => void;
}

export function MasterClassError({ onRetry }: MasterClassErrorProps) {
  useLanguage();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center mb-6">
        <AlertCircle className="h-10 w-10 text-destructive" />
      </div>
      <h3 className="text-xl font-semibold mb-2">
        {translateInterfaceText("Não foi possível carregar as aulas")}</h3>
      <p className="text-muted-foreground mb-6 max-w-md">
        {translateInterfaceText("Ocorreu um erro ao carregar o conteúdo. Verifique sua conexão e tente novamente.")}</p>
      <Button onClick={onRetry}>
        {translateInterfaceText("Tentar novamente")}</Button>
    </div>
  );
}
